import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  SidebarContainer,
  NavList,
  NavItem,
  MenuItem,
  ToggleIcon,
  SubMenu,
  SubMenuLink,
} from '../styles/FilterStyles';
import IconMais from '../imgs/icon-mais.png';
import IconMenos from '../imgs/icon-menos.png';
import data from '../data/products.json';

const Filter = () => {
  const [openStates, setOpenStates] = useState({});

  const categories = useMemo(() => {
    const result = {};
    const products = data.products;
  
    products.forEach(item => {
      const { category, subcategory, subCategoryFilter } = item;
  
      if (!result[category]) result[category] = {};
      if (!result[category][subcategory]) result[category][subcategory] = new Set();
  
      if (subCategoryFilter) result[category][subcategory].add(subCategoryFilter);
    });
  
    // Criar novo objeto ordenado
    const sortedResult = {};
  
    Object.keys(result).sort((a, b) => a.localeCompare(b)).forEach(category => {
      const sortedSubcategories = {};
      
      Object.keys(result[category])
        .sort((a, b) => a.localeCompare(b))
        .forEach(subcategory => {
          // Garante que estamos lidando com array
          sortedSubcategories[subcategory] = Array.from(result[category][subcategory]).sort((a, b) =>
            a.localeCompare(b)
          );
        });
  
      sortedResult[category] = sortedSubcategories;
    });
  
    return sortedResult;
  }, []);
  

  useEffect(() => {
    const initialState = {};
    Object.keys(categories).forEach((category) => {
      initialState[category] = { open: false };
      Object.keys(categories[category]).forEach((sub) => {
        initialState[`${category}-${sub}`] = { open: false };
      });
    });
    setOpenStates(initialState);
  }, [categories]);

  const toggleOpen = (key) => {
    setOpenStates((prev) => ({
      ...prev,
      [key]: { open: !prev[key]?.open },
    }));
  };

  return (
    <SidebarContainer>
      <NavList>
        {Object.keys(categories).map((category) => (
          <NavItem key={category}>
            <MenuItem onClick={() => toggleOpen(category)}>
              <Link
                to={`/category/${category}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <span>{category}</span>
              </Link>
              <ToggleIcon
                src={openStates[category]?.open ? IconMenos : IconMais}
                alt="toggle"
              />
            </MenuItem>

            {openStates[category]?.open && (
              <SubMenu>
                {Object.keys(categories[category]).map((subcategory) => (
                  <li key={subcategory}>
                    <MenuItem
                      onClick={() => toggleOpen(`${category}-${subcategory}`)}
                    >
                      <Link
                        to={`/category/${category}/${subcategory}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        <span>{subcategory}</span>
                      </Link>
                      {categories[category][subcategory].length > 0 && (
                        <ToggleIcon
                          src={
                            openStates[`${category}-${subcategory}`]?.open
                              ? IconMenos
                              : IconMais
                          }
                          alt="toggle"
                        />
                      )}
                    </MenuItem>

                    {openStates[`${category}-${subcategory}`]?.open && (
                      <SubMenu>
                        {categories[category][subcategory].map((subsub, i) => (
                          <li key={i}>
                            <SubMenuLink
                              to={`/category/${category}/${subcategory}/${subsub}`}
                            >
                              {subsub}
                            </SubMenuLink>
                          </li>
                        ))}
                      </SubMenu>
                    )}
                  </li>
                ))}
              </SubMenu>
            )}
          </NavItem>
        ))}
      </NavList>
    </SidebarContainer>
  );
};

export default Filter;
